import { CSSProperties } from 'react';

import { colors } from '@/utils';

const fillColor = colors.stroke.neutral['300'];
const iconWidth = '1rem';
const iconHeight = '1rem';
const menuIconWidth = '1.5rem';
const menuIconHeight = '1.5rem';
export const iconStyle: CSSProperties = {
  color: fillColor,
  minWidth: iconWidth,
  minHeight: iconHeight,
};

export const menuIonStyle: CSSProperties = {
  color: colors.text.info.on.soft['300'],
  minWidth: menuIconWidth,
  minHeight: menuIconHeight,
};
